import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const GrowFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill={color}
        d="M12 2C6.48 2 2 6.48 2 12c0 2.92 1.26 5.54 3.25 7.36.01-.01.02-.03.04-.05l5.84-5.11-2.25-2.06a.842.842 0 0 1-.27-.61c0-.23.1-.45.27-.61l3.4-3.04h-1.94c-.45 0-.82-.37-.82-.82 0-.45.37-.82.82-.82h4.02c.45 0 .82.37.82.82v4.11c0 .45-.37.82-.82.82-.45 0-.82-.37-.82-.82V8.96l-2.89 2.58 2.26 2.07c.17.16.27.38.27.62a.8.8 0 0 1-.28.61l-6.33 5.55A9.931 9.931 0 0 0 12.01 22c5.52 0 10-4.48 10-10S17.52 2 12 2Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default GrowFilled
